import laneTypes from "../../constants/laneTypes";
export default (function (homepageLanes, companyBenefitsTopOfHomepage) {
    if (companyBenefitsTopOfHomepage) {
        var indexOfCompanyBenefits = homepageLanes.findIndex(function (_a) {
            var type = _a.type;
            return type === laneTypes.COMPANY;
        });
        var companyLane = homepageLanes.splice(indexOfCompanyBenefits, 1)[0];
        homepageLanes.unshift(companyLane);
    }
    return homepageLanes;
});
